import { Pipe, PipeTransform } from '@angular/core';
/*

*/
@Pipe({name: 'notEmpty'})
export class NotEmptyPipe implements PipeTransform {
  transform(value: any): string {
    return value !== null ? value : '-';
  }
}